import { cn, Gallery, useMedias } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './PartnersList.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface PartnersListProps extends HTMLAttributes<HTMLDivElement> {
  list: string[];
}

const PartnersList: FC<PartnersListProps> = (props) => {
  const { list, className, ...restProps } = props;
  const { isMobile } = useMedias();

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      {isMobile ? (
        <Gallery spaceBetween={10}>
          {list.map((item) => (
            <div className={styles.imgContainer} key={item}>
              <Img src={item} className={styles.logo} alt='bank-logo' />
            </div>
          ))}
        </Gallery>
      ) : (
        list.map((item) => (
          <div key={item} className={styles.imgContainer}>
            <Img src={item} className={styles.logo} alt='bank-logo' />
          </div>
        ))
      )}
    </div>
  );
};

export default PartnersList;
